import MobileDrawer from '@c/drawers/MobileDrawer';
import { SmartPricingIcon } from 'app/create-listing/_components/FeaturesSection';
import { ChevronRight } from 'lucide-react';
import PriceDropIcon from './assets/price-drop-2.svg';
import Image from 'next/image';

export const PromoteModal = ({
  open,
  setOpen,
  setSmartPricingModalOpen,
  setPriceDropModalOpen,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSmartPricingModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setPriceDropModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const onSelectSmartPricing = () => {
    setOpen(false);
    setSmartPricingModalOpen(true);
  };

  const onSelecetPriceDrop = () => {
    setOpen(false);
    setPriceDropModalOpen(true);
  };

  return (
    <MobileDrawer
      show={open}
      dismiss={() => setOpen((prev) => !prev)}
      title="Promote your listing"
    >
      <div className="flex flex-col gap-12 px-8 py-12">
        <button
          className="flex items-center gap-5"
          onClick={onSelecetPriceDrop}
        >
          <Image
            src={PriceDropIcon}
            alt="smart pricing icon"
            width={56}
            height={56}
          />
          <div className="flex flex-col items-start gap-2">
            <span className="text-body-md font-semibold">Price drop</span>
            <p className="text-left text-body-sm font-medium text-text-muted">
              Drop the price and we’ll notify the people who liked your item
            </p>
          </div>
          <ChevronRight />
        </button>
        <div className="h-px w-full bg-[#d9d9d9]" />
        <button
          className="flex items-center gap-5"
          onClick={onSelectSmartPricing}
        >
          <SmartPricingIcon className="size-28" />
          <div className="flex flex-col items-start gap-2">
            <span className="text-body-md font-semibold">Smart pricing</span>
            <p className="text-left text-body-sm font-medium text-text-muted">
              Gradually lower the item price every 10 days until it reaches the
              floor price.
            </p>
          </div>
          <ChevronRight />
        </button>
      </div>
    </MobileDrawer>
  );
};
